"use client";

import ky from "ky";
import { useEffect, useState } from "react";

import { logError, serverRoutes } from "@up/data";

import type { ReactNode } from "react";

type Payload = {
  data: {
    catalogueItems: Array<{
      _id: string;
      name: string;
      inventoryItems: Array<{
        _id: string;
        name: string;
      }>;
    }>;
  };
};

type PartialCatalogueItem = {
  _id: string;
  name: string;
};

export function FetchCatalogueItems({
  baseURL,
  children,
  partnerID,
}: {
  baseURL: string;
  children: (props: {
    didError: boolean;
    isLoading: boolean;
    catalogueItems: PartialCatalogueItem[];
  }) => ReactNode;
  partnerID: string;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [didError, setDidError] = useState(false);
  const [catalogueItems, setCatalogueItems] = useState<PartialCatalogueItem[]>(
    [],
  );

  useEffect(function () {
    const go = async function () {
      setIsLoading(true);
      try {
        const url = `${baseURL}${serverRoutes.availableCohorts.allForApp(
          partnerID,
        )}`;

        const json = await ky.get(url).json<Payload>();
        setCatalogueItems(
          json.data.catalogueItems.filter((c) => c.inventoryItems.length > 0),
        );
      } catch (err) {
        setDidError(true);
        logError({ action: "LEAD_CAPTURE_FETCH_CATALOGUE", error: err, context: { partnerID } });
      }
      setIsLoading(false);
    };
    go();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children({
    didError,
    isLoading,
    catalogueItems,
  });
}
